import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import type React from "react";

type MetricCardProps = {
  metric: {
    title: string;
    icon: React.ReactNode;
    value: string | number;
    subtitle: string;
  };
};

const MetricCard = ({ metric }: MetricCardProps) => {
  return (
    <Grid size={{ xs: 6, sm: 6, md: 3 }} key={metric.title} className="">
      <Card className="rounded-2xl" sx={{ border: "1px solid #e5e5e5", boxShadow: "none" }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 0,
            }}
            className=" flex-row items-center"
          >
            <Typography
              variant="h2"
              className="text-nowrap m-0 tracking-[2px]"
              sx={{
                fontSize: "11px",
                fontWeight: 700,
                fontFamily: "var(--font-lato)",
                color: "var(--color-dust-ink)",
              }}
            >
              {metric.title.toUpperCase()}
            </Typography>
            <div className="text-primary-active flex flex-row items-center pb-1">{metric.icon}</div>
          </Box>
          <Typography
            variant="h3"
            sx={{
              mb: 0.5,
              fontWeight: 600,
              fontSize: "2.25rem",
              lineHeight: "2.25rem",
              letterSpacing: "-0.75px",
              color: "#333",
            }}
          >
            {metric.value.toLocaleString()}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {metric.subtitle}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default MetricCard;
